export const FORM_DATA_PARAM_NAME = "form_data"

export function getRawURLFormData(url: string) {
    return new URLSearchParams(url).get(FORM_DATA_PARAM_NAME)
}

export function parseURLFormData(url: string): Record<string, unknown> {
    const formDataRaw = getRawURLFormData(url)
    if (!formDataRaw) {
        return {}
    }

    try {
        return JSON.parse(atob(formDataRaw)) as Record<string, unknown>
    } catch (error) {
        return {}
    }
}

export function isSubsequentSession() {
    return window.location.href.includes("subsequent=1")
}
